export const bookmarkTitle = ({ theme }: Theme) => ({
  textAlign: "left",
  color:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[300] : theme.palette.primary.main,
  cursor: "pointer",
  fontSize: "0.875rem",
  fontWeight: 600,
});

export const bookmarkIconButton = ({ theme }: Theme) => ({
  color: theme.palette.mode === "dark" ? theme.custom.palette.light : theme.palette.grey[600],
  "> svg": {
    fontSize: "16px",
  },
});

export const bookmarkButton = ({ theme }: Theme) => ({
  color:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[200] : theme.palette.primary.main,
  fontSize: "0.625rem",
  marginBottom: theme.spacing(2),
  borderColor:
    theme.palette.mode === "dark" ? theme.custom.palette.blue[200] : theme.palette.primary.main,
});
